"use strict";
import React from "react";
import "art/modes/dom";
import { Group, Text } from "react-art";
import Rectangle from "react-art/shapes/rectangle";
import Vector from "immutable-vector2d";
import "../../api/api";
const getFontSize = (props) => props.canvasHeight * 12 / 792;
const TextElement = (props) => {
  return /* @__PURE__ */ React.createElement(Group, { x: props.x, y: props.y }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating ? 2 : 0,
      fill: "#fff"
    }
  ), /* @__PURE__ */ React.createElement(
    Text,
    {
      width: props.width,
      height: props.height,
      x: parseInt(props.width, 10) / 100,
      y: parseInt(props.height, 10) / 20,
      cursor: props.annotating ? "move" : "default",
      font: { fontSize: getFontSize(props) },
      stroke: "#333",
      fill: "#333"
    },
    (props.data || {}).text || "Edit text..."
  ));
};
TextElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
TextElement.typeID = "TextAnnotation";
TextElement.displayName = "TextAnnotation";
TextElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default TextElement;
